<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-ticket</v-icon>{{$t('ticket.ticketaction')}}</h1>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          color=""
          class="ml-sm-2"
          @click="resetForm"
        >
          {{ $t('global.reset')}}
        </v-btn>
        <v-btn
          :loading="isLoading"
          class="ml-sm-2"
          color="primary"
          @click="onSendTicketActionForm"
        >
          {{ $t('global.submit')}}
        </v-btn>
      </div>
    </v-toolbar>
    <TicketactionForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import TicketactionForm from '../../components/ticketaction/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Ticketaction';

const { mapFields } = createHelpers({
  getterType: 'ticketaction/getField',
  mutationType: 'ticketaction/updateField'
});

export default {
  name: 'TicketactionCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Loading,
    TicketactionForm
  },
  data() {
    return {
      item: {
        ticket: this.$route.params.parent,
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'uploaded', 'created', 'violations'])
  },
  methods: {
    ...mapActions('ticketaction', ['create','upload', 'reset']),
    onSendTicketActionForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  }
};
</script>
